import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Drawer } from '@zenlayer/zen-design';
import classNames from 'classnames';
import qs from 'query-string';
import { useEffect, useRef, useState } from 'react';
import { parseUrlSearch } from '../../common/utils';
import { Header } from './header';
import cls from './index.module.less';
import { RenderComponent } from './render-helper';
import { changeUrlByHistory, detailUrlParamsStringify, uniqueByKey, } from './util';
import { isArray } from '@zenlayer/zen-design/esm/_util/defineType';
import { generateUuid } from '@zenlayer/zen-design/esm/_util/utils';
import t from '@zenlayer/zen-intl18';
import { useSize } from 'ahooks';
import { emitter } from './events';
export * from './events';
const defaultDrawerWidth = '80%';
const fullScreenDrawerWidth = '100%';
const routeData = {
    routes: [],
    routeLabelIndex: '',
};
export const DetailDrawer = ({ className, style, useLocation, ...props }) => {
    const [drawerOpts, setDrawerOpts] = useState(null);
    const routeName = drawerOpts?.i18nKey ? t(drawerOpts.i18nKey) : '';
    const location = useLocation?.() || window.location;
    const [drawerWidth, setDrawerWidth] = useState(defaultDrawerWidth);
    const [contentKey, setContentKey] = useState(generateUuid());
    const scrollerRef = useRef(null);
    const scrollerInnerRef = useRef(null);
    const scrollerSize = useSize(scrollerRef);
    const scrollerInnerSize = useSize(scrollerInnerRef);
    useEffect(() => {
        const searchObj = parseUrlSearch(location.search);
        setDrawerWidth(searchObj.full_screen == 'true'
            ? fullScreenDrawerWidth
            : defaultDrawerWidth);
    }, [location.search]);
    useEffect(() => {
        const handleOpen = (data) => {
            if (isArray(data.customBreadCrumb)) {
                routeData.customBreadCrumb = data.customBreadCrumb?.map((item) => {
                    return {
                        currentPath: item.path,
                        content: item.name,
                    };
                });
            }
            else {
                routeData.customBreadCrumb = undefined;
            }
            setDrawerOpts(data || null);
            setContentKey(generateUuid());
        };
        const handleClose = () => {
            const { full_screen, addition_route, addition_name, addition_i18nKey, ...searchObj } = parseUrlSearch(window.location.search);
            if (addition_route) {
                const search = detailUrlParamsStringify({}, searchObj);
                changeUrlByHistory({ search }, 'replace');
            }
            setDrawerOpts(null);
            routeData.customBreadCrumb = undefined;
            drawerOpts?.onClose?.();
        };
        const handleSetRoutes = (data) => {
            const mergedRoutes = uniqueByKey([...routeData.routes, ...(data?.routes || [])], 'path');
            routeData.routeLabelIndex = data.routeLabelIndex;
            routeData.routes = mergedRoutes;
        };
        const handleCustomBread = (customBreadCrumb) => {
            routeData.customBreadCrumb = customBreadCrumb?.map((item) => {
                return {
                    currentPath: item.path,
                    content: item.name,
                };
            });
        };
        const historyStateHandler = function (event) {
            // event.state 包含当前历史记录条目的状态对象
            let searchObj = qs.parse(event?.target?.location?.search);
            if (!searchObj.addition_route) {
                handleClose();
            }
        };
        emitter.on('open-drawer', handleOpen);
        emitter.on('close-drawer', handleClose);
        emitter.on('set-routes', handleSetRoutes);
        emitter.on('set-custom-bread', handleCustomBread);
        window.addEventListener('popstate', historyStateHandler);
        return () => {
            routeData.customBreadCrumb = undefined;
            emitter.off('open-drawer', handleOpen);
            emitter.off('close-drawer', handleClose);
            emitter.off('set-routes', handleSetRoutes);
            emitter.off('set-custom-bread', handleCustomBread);
            window.removeEventListener('popstate', historyStateHandler);
        };
    }, []);
    return (_jsxs(Drawer, { ...props, className: classNames(className, cls.drawer), placement: "right", getContainer: false, mask: false, width: drawerWidth, open: !!drawerOpts, children: [_jsx(Header, { routes: routeData.routes, labelIndex: routeData.routeLabelIndex, customBreads: routeData.customBreadCrumb, onClose: () => {
                    emitter.emit('close-drawer');
                }, urlHref: drawerOpts?._urlHref || location?.href, addition: {
                    routeName,
                } }), _jsx("div", { className: classNames(cls.body), children: _jsx("div", { ref: scrollerRef, className: classNames(cls.scroller, {
                        [cls.scrollY]: !!scrollerSize &&
                            !!scrollerInnerSize &&
                            scrollerInnerSize.height > scrollerSize.height,
                    }), children: _jsx("div", { ref: scrollerInnerRef, children: drawerOpts !== null ? (drawerOpts.creatRoot === undefined &&
                            drawerOpts.react16Dom === undefined ? (_jsx("div", { children: drawerOpts.component }, contentKey)) : (_jsx(RenderComponent, { drawerOpts: drawerOpts }, contentKey))) : null }) }) })] }));
};
